import { render, staticRenderFns } from "./PostersCardComponent.vue?vue&type=template&id=464e68f0"
import script from "./PostersCardComponent.vue?vue&type=script&lang=js"
export * from "./PostersCardComponent.vue?vue&type=script&lang=js"
import style0 from "./PostersCardComponent.vue?vue&type=style&index=0&id=464e68f0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports